import { Money } from "@workspace/accounting/components";

import type { OrderItem } from "../../types";
import { COMPD_LABEL } from "../comp";

/** HA-658 slice 4 — the Payment screen's lines: a comped one reads Comp'd (£0) in place of its price, with its reason under the name. */
export function PaymentOrderLines({
	items,
	compedItemIds,
	compReasons,
}: {
	items: OrderItem[];
	compedItemIds: ReadonlySet<string>;
	compReasons?: ReadonlyMap<string, string>;
}) {
	return (
		<div className="space-y-1">
			{items.map((item) => (
				<div key={item.id} className="flex justify-between">
					<div>
						{item.name}
						{compReasons?.get(item.id) && (
							<div className="text-xs text-muted-foreground">
								Reason: {compReasons.get(item.id)}
							</div>
						)}
					</div>
					<div>
						{compedItemIds.has(item.id) ? (
							<span className="text-muted-foreground">{COMPD_LABEL}</span>
						) : (
							<Money {...item.price} />
						)}
					</div>
				</div>
			))}
		</div>
	);
}
